import { addDays, dayStr } from "../../lib/date";
import { profile } from "../../state/store";

/** 365-day GitHub-style activity heatmap. Columns are weeks, rows are
    weekdays, via CSS grid-auto-flow: column. */
export function Heatmap() {
  const p = profile.value;
  const today = dayStr();
  const days = Array.from({ length: 365 }, (_, i) => addDays(today, i - 364));

  return (
    <div class="heatmap" role="img" aria-label="365-day training activity">
      {days.map((day) => {
        const ring = p.rings[day];
        const intensity = ring ? Math.min(1, 0.28 + (ring.clarity / 150) * 0.72) : 0;
        const cls = ["heatmap-cell", ring?.closed && "heatmap-closed", ring && !ring.closed && "heatmap-partial"]
          .filter(Boolean)
          .join(" ");
        return <span key={day} class={cls} style={ring ? { opacity: intensity } : undefined} title={day} />;
      })}
    </div>
  );
}
